export default "__VITE_ASSET__BUlPpOFO__"